<template>
  <div class="socialSecurity">
    <div class="dateWrapper">
      <div class="date" @click="handlerDate">{{ dateInfo }}
        <van-icon name="arrow-down" />
      </div>
      <van-popup v-model="show" position="bottom" class="pick" round>
        <van-datetime-picker v-model="currentDate" type="year-month" :formatter="formatter" :max-date="maxDate"
          :min-date="minDate" @confirm="confirmMonth" @cancel="show = false" />
      </van-popup>
    </div>
    <div class="accumulationFund">
      <!-- 项目 -->
      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>公积金</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.accu_er">{{ salaryDetail.accu_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.accu_ee">{{ salaryDetail.accu_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
      </div>

      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>养老保险</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.pens_er">{{ salaryDetail.pens_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.pens_ee">{{ salaryDetail.pens_ee }} ¥</div>
          <div v-else>- -</div>

        </div>
      </div>

      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>失业保险</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.unem_er">{{ salaryDetail.unem_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.unem_ee">{{ salaryDetail.unem_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
      </div>
      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>医疗保险</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.medi_er">{{ salaryDetail.medi_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.medi_ee">{{ salaryDetail.medi_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
      </div>
      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>补充医疗保险</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.bene1_er">{{ salaryDetail.bene1_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.bene1_ee">{{ salaryDetail.bene1_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
      </div>
      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>生育保险</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.mate_er">{{ salaryDetail.mate_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.mate_ee">{{ salaryDetail.mate_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
      </div>
      <div class="project-item">
        <div class="name">
          <div>项目</div>
          <div>社保补缴/调整/退费</div>
        </div>
        <div>
          <div class="title">公司</div>
          <div v-if="salaryDetail.supply_er">{{ salaryDetail.supply_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">个人</div>
          <div v-if="salaryDetail.supply_ee">{{ salaryDetail.supply_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
      </div>
      <!-- 小计 -->
      <div class="total-item project-item">
        <div>
          <div class="title">公积金公司小计</div>
          <div v-if="salaryDetail.total_acc_er" class="money">{{ salaryDetail.total_acc_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">公积金个人小计</div>
          <div v-if="salaryDetail.total_acc_ee" class="money">{{ salaryDetail.total_acc_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">社保公司小计</div>
          <div v-if="salaryDetail.total_ben_er" class="money">{{ salaryDetail.total_ben_er }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          <div class="title">社保个人小计</div>
          <div v-if="salaryDetail.total_ben_ee" class="money">{{ salaryDetail.total_ben_ee }} ¥</div>
          <div v-else>- -</div>
        </div>
        <div>
          备注
          <van-field v-model="salaryDetail.remark" rows="4" autosize type="textarea" readonly />
        </div>
      </div>

      <!-- 按钮 -->
      <div class="footer">
        <div class="close">
          <el-button @click="cancel">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import moment from "moment";
export default {
  name: "socialSecurity",
  components: {},

  data() {
    return {
      salaryDetail: {},
      currentDate: new Date(),
      show: false,
      dateInfo: moment(new Date()).format('YYYY-MM'),
      month: '',
      maxDate: new Date(),
      minDate: new Date("2023/01/01"),
    };
  },
  mounted() {
    this.querySalaryData();
  },
  methods: {
    // 获取工资信息
    querySalaryData() {
      api.getSalary(
        {
          month: this.month
        }
      ).then(res => {
        this.salaryDetail = res.data;
        this.dateInfo = moment(res.data.month).format('YYYY-MM');
        this.currentDate = new Date(res.data.month);
        // this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      });
    },
    // 返回
    cancel() {
      this.$router.push('/mobile/home');
    },

    // 选择月份
    confirmMonth(e) {
      this.dateInfo = moment(e).format('YYYY-MM');
      this.month = moment(e).format('YYYY-MM');
      this.salaryDetail = {};
      this.querySalaryData();
      this.show = false;

    },
    // 格式化日期
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    //显示日期选择器
    handlerDate() {
      this.show = true;
    }
  },
};
</script>
<style scoped lang="scss">
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .socialSecurity {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .socialSecurity {
    width: 276px * $zoom;
  }
}

.socialSecurity {
  font-size: 12px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;

  .dateWrapper {
    background-color: #fff;
    display: flex;

    padding: 20px 30px;

    .date {
      border: 1px solid rgb(223, 219, 219);
      padding: 10px;
      border-radius: 10px;
    }

    .pick {
      ::v-deep .van-picker__toolbar {
        height: 40px * $zoom;

        .van-picker__confirm,
        .van-picker__cancel {
          font-size: 11px * $zoom;
        }
      }

      ::v-deep .van-ellipsis {
        font-size: 26px;
      }
    }
  }

  ::v-deep .van-cell {
    border: 1px solid #e9e9e9;
    margin-top: 10px;
  }

  .accumulationFund {
    // height: 20px * $zoom !important;
    width: 100%;
    // position: sticky;
    // top: 0;
    // z-index: 111;
    display: flex;
    flex-direction: column;

    .project-item {
      margin-top: 20px;
      padding: 20px;
      width: 100%;
      background-color: #fff;
      font-size: 29px;

      >div {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          color: #bbbbbb;
        }
      }

      >div:nth-child(2) {
        border-bottom: 1px solid #ccc;
      }
    }

    .project-item:nth-child(1) {
      margin-top: 0;
    }



    .total-item {
      >div {
        border-bottom: 1px solid #ccc;

        .title {
          color: black;
        }

        .money {
          color: red;
        }
      }

      >div:last-child {
        display: block;
        border: none;

        .message {
          margin-top: 20px;
          width: 100%;
          min-height: 100px;
        }
      }
    }

    .footer {
      display: flex;
      background-color: #fff;
      justify-content: center;
      padding-bottom: 20px;

      .close {
        width: 100%;
        display: flex;
        justify-content: center;

        .el-button {
          color: #fff;
          background-color: #63a17d;
          font-size: 29px;
        }
      }

      ::v-deep(.el-button) {
        width: 100%;
        height: 80px;
        border-radius: 0;
        border: 0;
      }

      .check {
        width: 70%;

        .el-button {
          background-color: #63a17d;
          color: white;
        }
      }
    }
  }

  cd ::v-deep .van-tab {
    font-size: 15px * $zoom;
    line-height: 30px * $zoom !important;
  }

  ::v-deep .van-tabs__line {
    width: 60px * $zoom;
    border-bottom: 2px solid green;
    background: none;
  }

  ::v-deep .van-tabs__content {
    padding: 10px * $zoom;
  }
}</style>
